import type { IMetaTag } from '@sravni/types/lib/seo';

export type RobotsMetaTag = {
  name: string;
  content: string;
};

const INDEX_FOLLOW = 'index, follow';
const NOINDEX_NOFOLLOW = 'noindex, nofollow';

const isNoindex = (value?: string) => Boolean(value?.includes('noindex'));

export const getRobotsMetaTags = (metaTags?: IMetaTag[]): RobotsMetaTag => {
  if (!metaTags?.length) {
    return { name: 'robots', content: NOINDEX_NOFOLLOW };
  }

  const googleValue = metaTags.find((tag) => tag.name === 'googlebot')?.value;
  const yandexValue = metaTags.find((tag) => tag.name === 'yandex')?.value;

  const googleBlocked = isNoindex(googleValue);
  const yandexBlocked = isNoindex(yandexValue);

  if (googleBlocked && yandexBlocked) {
    return { name: 'robots', content: NOINDEX_NOFOLLOW };
  }

  if (!googleBlocked && !yandexBlocked) {
    return { name: 'robots', content: INDEX_FOLLOW };
  }

  if (googleBlocked) {
    return { name: 'googlebot', content: NOINDEX_NOFOLLOW };
  }

  return { name: 'yandex', content: NOINDEX_NOFOLLOW };
};
